import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '../components/layout/Navbar';
import { Card, Badge, Spinner } from '../components/ui';
import { orderApi } from '../services/api';
import { ORDER_STATUS_MAP } from '../constants';

const LOCALE_MAP = { uz_latin: 'uz-UZ', uz_cyrl: 'uz-Cyrl-UZ', ru: 'ru-RU' };

export default function BuyurtmalarPage() {
  const { t, i18n } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    orderApi.getMyOrders()
      .then((data) => setOrders(Array.isArray(data) ? data : []))
      .catch(() => setOrders([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <PageLayout>
      <div className="max-w-2xl mx-auto py-6">
        <h1 className="text-3xl font-black italic uppercase mb-8">{t('main.myOrders')}</h1>
        {loading ? (
          <div className="flex justify-center py-20"><Spinner /></div>
        ) : orders.length === 0 ? (
          <Card className="p-12 text-center text-slate-400 font-bold uppercase text-[10px] tracking-widest">
            {t('main.noOrders')}
          </Card>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => {
              const meta = ORDER_STATUS_MAP[o.status] || { label: o.status, color: 'slate' };
              return (
                <Card key={o.id} className="p-6 flex justify-between items-center rounded-3xl">
                  <div>
                    <p className="font-black text-slate-900 dark:text-white">{o.quantity} ta · {Number(o.totalPrice).toLocaleString()} UZS</p>
                    <p className="text-[10px] text-slate-400 uppercase mt-1">
                      {new Date(o.createdAt).toLocaleString(LOCALE_MAP[i18n.language] || 'uz-UZ')}
                    </p>
                  </div>
                  <Badge variant={meta.color}>{meta.label}</Badge>
                </Card>
              );
            })}
          </div>
        )}
      </div>
    </PageLayout>
  );
}
